import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';

import { CookieConsent, OPTIONS } from 'react-cookie-consent';

type CustomCookieConsentProps = {
    className?: string,
    style?: React.CSSProperties,
};

CustomCookieConsent.defaultProps = {
    className: '',
    style: {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    cookieConsentContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 4),
        backgroundColor: theme.palette.primary.main,
        borderBottomColor: 'rgba(255, 255, 255, .3)',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        color: theme.palette.common.white,
        '& a': {
            color: theme.palette.common.white,
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            padding: theme.spacing(2),
        },
    },
    button: {
        margin: theme.spacing(0, 0, 0, 2),
        padding: theme.spacing(1, 3),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white,
        borderStyle: 'solid',
        borderWidth: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(2, 0, 0, 0),
        },
    },
}));

function CustomCookieConsent(props: CustomCookieConsentProps): React.ReactElement {
    const {
        className,
        style = CustomCookieConsent.defaultProps.style,
    } = props;
    const classes = useStyle();

    return (
        <CookieConsent
            location={OPTIONS.TOP}
            buttonText="同意使用"
            cookieName="uicsCookieAccept"
            containerClasses={classes.cookieConsentContainer}
            style={{ zIndex: 9999 }}
            buttonClasses={classes.button}
            disableStyles
        >
            為增進此網站功能我們將在您的裝置上傳送Cookies功能。當您繼續瀏覽本網站，我們將推定您已同意使用Cookies，詳見[<Link href="/privacy">隱私權政策</Link>] [<Link href="/terms">使用條款</Link>]。
        </CookieConsent>
    );
}

export { CustomCookieConsent };
